import { createSelector } from 'reselect';
const selectFileState = (fileState) => fileState;
const selectParentId = (fileState, parentId) => parentId;
export const getThumbnailFileInfo = createSelector([selectFileState, selectParentId], (fileState, parentId) => {
    for (let index = 0; index < fileState.allIds.length; index++) {
        if (fileState.byId[fileState.allIds[index]].parentId === parentId) {
            return fileState.byId[fileState.allIds[index]];
        }
    }
    return undefined;
});
//# sourceMappingURL=getThumbnailFileInfo.js.map